module.exports = __webpack_public_path__ + "img/camera.5a13e837.svg";